/*!*
 * @author yueheqin
 * @date 2019/7/4
 * @project zujuanzaixian
 * @desc
 */
import Vue from 'vue'
import {
  collectCancelApi,
  collectQuesApi,
  singleDownApi,
  commentApi,
  correctApi,
  searchConfigApi,
  mxmjConfigApi,
  saveTmpPaperApi,
  getTmpPaperApi,
  canPowerApi
} from '../../api/zujuan'
import { createMaps } from '../../utils/create-maps'
import { renderMathML } from '../../views/utils/render-mathml'

const diffArr = [
  {
    id: 1,
    name: '容易'
  },
  {
    id: 2,
    name: '较易'
  },
  {
    id: 3,
    name: '一般'
  },
  {
    id: 4,
    name: '较难'
  },
  {
    id: 5,
    name: '困难'
  }
]
const testStyleMap = {
  0: '默认',
  1: '选择题',
  2: '选择非选择',
  3: '非选择'
}
let state = {
  mxmjOption: {},
  searchOption: {},
  wordDownConfig: {},
  powerText: ''
}

let getters = {
  mxmjOption (state) {
    return state.mxmjOption
  },
  searchOption (state) {
    return state.searchOption
  },
  wordDownConfig (state) {
    return state.wordDownConfig
  },
  diffArr () {
    return diffArr
  },
  diffArrMap () {
    return createMaps(diffArr, 'id', 'name')
  },
  testStyleMap () {
    return testStyleMap
  },
  powerText (state) {
    return state.powerText
  }
}

let mutations = {
  saveMXMJOption (state, val) {
    state.mxmjOption = val
  },
  saveSearchOption (state, val) {
    state.searchOption = val
  },
  saveWordDownConfig (state, val) {
    console.log('mutations saveWordDownConfig', val)
    state.wordDownConfig = val
  },
  savePowerText (state, val) {
    state.powerText = val
  }
}

let actions = {
  saveTmpPaper ({ state, commit, rootState, rootGetters }, paper) {
    let subjectID = rootGetters['common/currentSubject'].id
    Vue.nextTick(() => {
      renderMathML()
    })

    // paper 是否有 saved字段
    paper.saved = paper.saved || 0

    saveTmpPaperApi({ subjectID, paper: Object.assign({}, paper) }).then(res => {
      console.info(res.data)
    })
  },
  saveTmpPaperLast ({ state, commit, rootState, rootGetters }, paper) {
    let subjectID = rootGetters['common/currentSubject'].id
    saveTmpPaperApi({ subjectID, paper: Object.assign({}, paper), type: 1 }).then(res => {
      console.info(res.data)
    })
    // setTimeout(() => {
    //
    // }, 1000)
    // setTimeout(() => {
    //
    // }, 1000)
  },
  getTmpPaper ({ state, commit, rootGetters }, cb) {
    let subjectID = rootGetters['common/currentSubject'].id
    if (!rootGetters['user/isLogin']) return
    getTmpPaperApi({ subjectID }, {loading: '1', silent: '1'}).then(res => {
      cb(res.data)
    })
  },
  getTmpPaperReset ({ rootGetters }) {
    let subjectID = rootGetters['common/currentSubject'].id
    return new Promise((resolve, reject) => {
      getTmpPaperApi({ subjectID, type: 1 }, {loading: '1', loadingText: '正在恢复试题...'}).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取名校名卷配置
  getMXMJOption ({ state, commit }, payload) {
    mxmjConfigApi(payload).then((res) => {
      let data = res.data
      commit('saveMXMJOption', data)
    })
  },
  // 获取搜索配置
  getSearchOption ({ state, commit }, payload) {
    searchConfigApi(payload).then((res) => {
      let data = res.data
      commit('saveSearchOption', data)
    })
  },
  // 收藏
  collectQues (state, payload) {
    console.log('collectQues action', payload)
    return new Promise((resolve, reject) => {
      collectQuesApi(payload.data, payload.config).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 取消收藏
  collectQuesCancel (state, {params, config}) {
    console.log('collectQuesCancel action', params, config)
    return new Promise((resolve, reject) => {
      collectCancelApi(params, config).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 单题下载
  singleDown (state, payload) {
    console.log('singleDown action', payload)
    return new Promise((resolve, reject) => {
      singleDownApi(payload.data, payload.config).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 试题评价
  commentTest (state, payload) {
    console.log('commentTest action', payload)
    return new Promise((resolve, reject) => {
      commentApi(payload.data, payload.config).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 试题纠错
  correctTest (state, payload) {
    console.log('correctTest action', payload)
    return new Promise((resolve, reject) => {
      correctApi(payload.data, payload.config).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取权限信息
  canPower ({commit, rootGetters}, payload) {
    if (!rootGetters['user/isLogin']) return
    canPowerApi({powerTag: payload}, {silent: '1'}).then(res => {
      commit('savePowerText', res.data)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
